import { useMemo } from 'react'

import { FormDropdown } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { GLOBAL_PARTNER_FORM_KEY } from '../../../../../../../../components/globalPartnerTable/components/globalPartnerDetailsContent/configs'
import { GLOBAL_PARTNER_TYPE_OPTIONS } from '../../../../../../../../components/globalPartnerTypeButtons/configs'

interface IGlobalFormRtmSelect {
  defaultValue: string
  isNewGlobalPartner?: boolean
}

export const GlobalFormRtmSelect = ({ defaultValue, isNewGlobalPartner }: IGlobalFormRtmSelect) => {
  const source = useMemo(() => {
    return new Crud({
      fetcher: new Static(GLOBAL_PARTNER_TYPE_OPTIONS.map((el) => ({ key: el }))),
      keyField: 'key',
    })
  }, [])

  return (
    <FormDropdown
      isDisabled={!isNewGlobalPartner}
      isRequired
      isStatic
      source={source}
      formKey={GLOBAL_PARTNER_FORM_KEY}
      field="rtm"
      defaultValue={defaultValue}
      type="text"
      label="RTM"
      caption="key"
      validationType={ValidationType.ONCHANGE}
    />
  )
}
